import React, { useState } from "react";

const services = ["Yoga", "Naturopathy", "Therapy"];

function Appointment() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    date: "",
    time: "",
    service: services[0],
  });
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const errs = {};
    if (!form.name) errs.name = "Name is required.";
    if (!form.email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email)) errs.email = "Valid email required.";
    if (!form.mobile || !/^\d{10}$/.test(form.mobile)) errs.mobile = "Enter 10-digit mobile number.";
    if (!form.date) errs.date = "Date required.";
    if (!form.time) errs.time = "Time required.";
    if (!form.service) errs.service = "Select a service.";
    return errs;
  };

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    const errs = validate();
    setErrors(errs);
    if (Object.keys(errs).length === 0) {
      setSubmitted(true);
    }
  };

  return (
    <div className="max-w-xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold mb-6 text-green-800">Book an Appointment</h1>
      <form onSubmit={handleSubmit} className="bg-white shadow rounded p-6 flex flex-col gap-4">
        <input name="name" value={form.name} onChange={handleChange} required placeholder="Your Name" className="border rounded px-3 py-2" />
        {errors.name && <div className="text-red-600 text-sm">{errors.name}</div>}
        <input name="email" type="email" value={form.email} onChange={handleChange} required placeholder="Your Email" className="border rounded px-3 py-2" />
        {errors.email && <div className="text-red-600 text-sm">{errors.email}</div>}
        <input name="mobile" value={form.mobile} onChange={handleChange} required placeholder="Mobile Number" className="border rounded px-3 py-2" />
        {errors.mobile && <div className="text-red-600 text-sm">{errors.mobile}</div>}
        <input name="date" type="date" value={form.date} onChange={handleChange} required className="border rounded px-3 py-2" />
        {errors.date && <div className="text-red-600 text-sm">{errors.date}</div>}
        <input name="time" type="time" value={form.time} onChange={handleChange} required className="border rounded px-3 py-2" />
        {errors.time && <div className="text-red-600 text-sm">{errors.time}</div>}
        <select name="service" value={form.service} onChange={handleChange} className="border rounded px-3 py-2">
          {services.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        {errors.service && <div className="text-red-600 text-sm">{errors.service}</div>}
        <button type="submit" className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700">Book Now</button>
        {submitted && <div className="text-green-700 mt-2">Thank you! Your appointment has been booked.</div>}
      </form>
    </div>
  );
}

export default Appointment;
